import { FC, useEffect, useState } from 'react'
import { IBusinessLabel } from '../../model/labels'
import { DropDownListSelected } from '../dropDownSelected'
import { IItem } from '../../model/types'
import classes from './labels.module.scss'

interface IProps {
    value: string[];
    onChange: (labels: string[]) => void;
    loadOptions: () => Promise<IBusinessLabel[]>;
    title?: string;
    singleLine?: boolean;
}

export const LabelsFilter: FC<IProps> = ({value, onChange, loadOptions, title = 'Лейблы', singleLine = false}) => {
    const [options, setOptions] = useState<IBusinessLabel[]>([])
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        let active = true
        loadOptions().then(items => { if(active) setOptions(items) }).catch(() => { if(active) setOptions([]) }).finally(() => { if(active) setLoading(false) })
        return () => { active = false }
        // The dictionary is immutable for the lifetime of a mounted filter.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const items: IItem<string>[] = options.map(label => ({id: label.text, name: label.text}))
    const onSelected = (item: IItem<string>) => (selected: boolean) => onChange(selected
        ? (value.includes(item.id) ? value : [...value, item.id])
        : value.filter(text => text !== item.id))
    return <section className={`${classes.filter}${singleLine ? ` ${classes.filterSingleLine}` : ''}`}>
        <span className={classes.filterTitle}>{title}:</span>
        <section className={classes.selector}>
            <DropDownListSelected
                items={items}
                selectedIdItems={value}
                onSelected={onSelected}
                onSelectAll={onChange}
                selectedCount
                isLoading={loading}
                placeholder="Выберите лейблы"
                search
                searchPlaceholder="Поиск по лейблам"
                emptyText="Лейблы не найдены"
            />
        </section>
        {value.length > 0 && <button type="button" className={classes.clear} onClick={() => onChange([])}>Сбросить</button>}
    </section>
}
